export class ConsoleNotifier {
    info(title, message) {
        this.log(title, message, "info");
    }
    success(title, message) {
        this.log(title, message, "success");
    }
    debug(title, message) {
        this.log(title, message, "debug");
    }
    warn(title, message) {
        this.log(title, message, "warn");
    }
    error(title, message) {
        this.log(title, message, "error");
    }
    confirmation(title, message, buttons, callback) {
        throw new Error("Console Notifier cannot ask questions!");
    }
    log(title, message, level) {
        switch (level) {
            case "debug":
                // eslint-disable-next-line no-restricted-syntax
                console.debug(title + " - " + message);
                break;
            case "error":
                console.error(title + " - " + message);
                break;
            case "warn":
                console.warn(title + " - " + message);
                break;
            case "info":
            case "success":
            default:
                console.log(title + " - " + message);
        }
    }
}
